function Size(props){

    const { id, size, onClick, currentSize, quantity} = props
    
    return(
         <div className="flex one center">
               <div className={`shadow flex center size-box ${currentSize == size? 'orange':'white'}`} onClick={onClick}>
                   <span className={`${currentSize == size? 'white-txt':'brown'} small-txt`}>{size}</span>
               </div>
         </div>
    )
}

export default Size;